<template>
  <div class="hero" :class="{ 'is-dark': dark }">
    <div class="hero_background"></div>
    <b-row class="hero-container" :style="heroContainerStyles">
      <div class="hero-content">
        <div class="hero-title" v-html="hero.title"></div>
        <div class="hero-subtitle" v-html="hero.subtitle"></div>
        <div v-if="hero.list" class="hero-list">
          <div v-for="item in hero.list" :key="item.id" class="hero-list-item">
            <i class="icon-checkmark fs13 text-blue-900 pr-10"></i>
            <p v-html="item.text"></p>
          </div>
        </div>

        <p class="price pt-20">{{ hero.price }}</p>

        <div
          v-if="hero.button.external"
          class="hero-external_btn"
          :style="{
            'background-color': hero.button.backgroundColor,
            color: hero.button.color
          }"
          @click="handleButtonClick()"
        >
          {{ hero.button.label }}
        </div>
        <router-link
          v-else
          :to="hero.button.link"
          class="btn btn-lg"
          :class="{ 'btn-green': dark }"
          :target="hero.button.newTab ? '_blank' : '_self'"
          >{{ hero.button.label }}</router-link
        >
        <div
          class="scout-caption"
          v-html="hero.caption"
          @click="hero.button.secondaryAction && hero.button.secondaryAction()"
        ></div>
      </div>

      <div class="hero-img_and_pattern">
        <img :src="hero.image" alt="man" class="hero-img_and_pattern-img" :style="photoStyles" />
        <img
          :src="require('~/assets/pages/scout/red_pattern.svg')"
          class="hero-img_and_pattern-pattern"
        />
      </div>
    </b-row>
    <Container
      class="hero-companies_block_container"
      :bounds-inner-styles="{ 'padding-top': '24px', 'padding-bottom': '2rem' }"
    >
      <div class="hero-companies_block_wrapper" v-if="hero.companies">
        <div class="hero-company-node" style="width: 240px; max-width: unset;">
          Startups we helped hire 🚀
        </div>
        <div class="hero-companies_wrapper">
          <div v-for="item in hero.companies" :key="item.id">
            <img :src="item.logo" class="hero-company-node" />
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import Container from '@/components/Container';

export default {
  name: 'ScoutHero',
  components: {
    Container
  },
  props: {
    hero: {
      type: Object,
      required: true
    },
    dark: Boolean,
    hasPanel: {
      type: Boolean
    },
    photoStyles: {
      type: String,
      required: false
    },
    heroContainerStyles: {
      type: Object,
      required: false
    }
  },
  methods: {
    handleButtonClick() {
      // window.open(this.hero.button.link, '_blank')
      this?.hero?.button?.action();
    }
  }
};
</script>

<style lang="scss" scoped>
.scout-caption {
  color: #818975;
  margin-top: 0.7rem;
  width: 15rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-companies_block_wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  @include media-breakpoint-down(md) {
    flex-direction: column;
    display: none;
  }
  @include media-breakpoint-down(sm) {
    display: none;
  }
}
.hero-companies_wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 240px);
  @include media-breakpoint-down(md) {
    width: calc(100% - 0px);
  }
  @include media-breakpoint-down(sm) {
    width: calc(100% - 0px);
    flex-direction: column;
  }
}
.hero-company-node {
  color: #484f66;
  font-size: rem(16px);
  line-height: rem(26px);
  max-height: rem(30px);
  max-width: rem(90px);
  @include media-breakpoint-down(sm) {
    margin-top: 20px;
  }
}
.hero-title {
  margin-top: 3rem;
  margin-bottom: 1rem;
  font-weight: 700;
  line-height: 1.2;
  font-size: rem(48px);
}
.hero-subtitle {
  font-weight: 400;
  font-size: rem(18px);
  color: #51596c;
  // margin-bottom: rem(30px);
}
.hero-img_and_pattern {
  // position: relative;
  // @include media-breakpoint-down(xs) {
  //   display: none;
  // }
  @include media-breakpoint-down(sm) {
    display: none;
  }
  // @include media-breakpoint-down(md) {
  //   display: none;
  // }
  // @include media-breakpoint-down(lg) {
  //   display: none;
  // }
  // @include media-breakpoint-down(xl) {
  //   display: none;
  // }
}
.hero-img_and_pattern-img {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  height: 100%;
  width: auto;
  object-fit: cover;
  @include media-breakpoint-down(xl) {
    width: 37%;
  }
}
.hero-img_and_pattern-pattern {
  position: absolute;
  bottom: rem(-80px) !important;
  transform: scale(0.85);
  right: -1.5rem;
  z-index: 2;
  @include media-breakpoint-down(lg) {
    // padding-right: rem(30px) !important;
  }
}
.hero_background {
  width: 100%;
  height: rem(520px);
  // background-color: #f5f7fa;
  position: absolute;
  top: 5rem;
  left: 0;
  z-index: 0;
}
.hero-external_btn {
  height: 4rem;
  width: 15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  cursor: pointer;
  padding-left: 3rem;
  padding-right: 3rem;
}
.hero {
  padding-top: rem(60px);
  padding-bottom: rem(40px);
  @include media-breakpoint-down(sm) {
    padding-bottom: 0px;
    margin-bottom: -4rem;
  }
}

.hero-content {
  position: relative;
  z-index: 2;
  // max-width: 700px;
  max-width: 1360px;
  flex: 0 0 60%;

  @include media-breakpoint-down(sm) {
    flex: 0 0 100%;
  }
}
.note {
  font-size: 0.8rem;
  color: $gray-600;
  color: $baltic-blue;
}

.price {
  font-size: rem(40px);
  color: $dark-blue;
  font-weight: 800;
}
.hero-list {
  max-width: rem(554px);
  .hero-list-item {
    display: inline-flex;
    align-items: baseline;
    padding-bottom: rem(20px);

    p {
      color: $ash-blue;
      font-size: rem(18px);
    }
  }
}
.hero-container {
  margin: 0 auto;
  background-color: $blue-200;
  position: relative;
  z-index: 1;
  padding-top: rem(60px) !important;
  padding-bottom: rem(50px) !important;
  padding-left: rem(125px) !important;
  padding-right: rem(125px) !important;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  // overflow: hidden;

  @include media-breakpoint-up(xl) {
    max-width: 1360px !important;
  }

  @include media-breakpoint-down(lg) {
    padding-left: rem(15px) !important;
    padding-right: rem(15px) !important;
  }

  @include media-breakpoint-down(md) {
    padding-left: rem(15px) !important;
    padding-right: rem(15px) !important;
  }

  @include media-breakpoint-down(sm) {
    height: auto;
  }
}
</style>
